import type { ReactNode } from 'react';

/**
 * CSS scale so apparent bond/atom size matches a reference slot; export W/H changes
 * then only change margins/cropping unless user adjusts zoom/pan.
 */
export function AtomScaleWrap({
  compensation,
  children,
  anchor = 'center',
}: {
  compensation: number;
  children: ReactNode;
  anchor?: 'left' | 'center' | 'right';
}) {
  const transformOrigin =
    anchor === 'left' ? 'left center' : anchor === 'right' ? 'right center' : 'center center';
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          transform: `scale(${compensation})`,
          transformOrigin,
        }}
      >
        {children}
      </div>
    </div>
  );
}
